var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_180",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6 42H10C8.9 42 7.95833 41.6083 7.175 40.825C6.39167 40.0417 6 39.1 6 38V30.4C7.6 30.4 9 29.8917 10.2 28.875C11.4 27.8583 12 26.5667 12 25C12 23.4333 11.4 22.1417 10.2 21.125C9 20.1083 7.6 19.6 6 19.6V12C6 10.9 6.39167 9.95833 7.175 9.175C7.95833 8.39167 8.9 8 10 8H18C18 6.6 18.4833 5.41667 19.45 4.45C20.4167 3.48333 21.6 3 23 3C24.4 3 25.5833 3.48333 26.55 4.45C27.5167 5.41667 28 6.6 28 8H36C37.1 8 38.0417 8.39167 38.825 9.175C39.6083 9.95833 40 10.9 40 12V20C41.4 20 42.5833 20.4833 43.55 21.45C44.5167 22.4167 45 23.6 45 25C45 26.4 44.5167 27.5833 43.55 28.55C42.5833 29.5167 41.4 30 40 30V38C40 39.1 39.6083 40.0417 38.825 40.825C38.0417 41.6083 37.1 42 36 42H28.4C28.4 40.3333 27.875 38.9167 26.825 37.75C25.775 36.5833 24.5 36 23 36C21.5 36 20.225 36.5833 19.175 37.75C18.125 38.9167 17.6 40.3333 17.6 42ZM10 38H14.25C15.05 35.8 16.3333 34.25 18.1 33.35C19.8667 32.45 21.5 32 23 32C24.5 32 26.1333 32.45 27.9 33.35C29.6667 34.25 30.95 35.8 31.75 38H36V26H40C40.2667 26 40.5 25.9 40.7 25.7C40.9 25.5 41 25.2667 41 25C41 24.7333 40.9 24.5 40.7 24.3C40.5 24.1 40.2667 24 40 24H36V12H24V8C24 7.73333 23.9 7.5 23.7 7.3C23.5 7.1 23.2667 7 23 7C22.7333 7 22.5 7.1 22.3 7.3C22.1 7.5 22 7.73333 22 8V12H10V16.4C11.8 17.0667 13.25 18.1833 14.35 19.75C15.45 21.3167 16 23.0667 16 25C16 26.9 15.45 28.6333 14.35 30.2C13.25 31.7667 11.8 32.9 10 33.6V38Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugins);
export default __webpack_public_path__ + "static/media/plugins.f3f731db6e0f78c3f6c32e6045286dc0.svg";
export { ForwardRef as ReactComponent };